import { motion } from "framer-motion";

const LeadModal = ({ lead, onClose, onReply, getStatusStyle }) => {
  if (!lead) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-end sm:items-center justify-center p-0 sm:p-4 sm:p-6 bg-[#0B1C2D]/60 backdrop-blur-md overflow-y-auto">
      <motion.div
        initial={{ scale: 0.95, opacity: 0, y: 30 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.95, opacity: 0, y: 30 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="bg-white w-full max-w-2xl rounded-t-[28px] sm:rounded-[32px] shadow-2xl overflow-hidden my-0 sm:my-auto border border-slate-100 max-h-[92dvh] overflow-y-auto"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <header className="bg-[#0B1C2D] p-6 md:p-8 text-white flex justify-between items-start relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#E63946] blur-[60px] opacity-40"></div>
          <div className="relative z-10">
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <span className="px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest bg-[#E63946] text-white shadow-sm">
                {lead.serviceRequested}
              </span>
              <span
                className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest shadow-sm ${getStatusStyle(
                  lead.status,
                )}`}
              >
                {lead.status || "Pending"}
              </span>
            </div>
            <h3 className="text-2xl md:text-3xl font-black tracking-tight mb-1">
              {lead.sender}
            </h3>
            <p className="text-slate-400 text-xs font-bold uppercase tracking-widest flex items-center gap-1.5">
              <span className="material-symbols-outlined text-[14px]">
                business
              </span>
              {lead.companyName !== "N/A"
                ? lead.companyName
                : "Independent Project"}
            </p>
          </div>
          <button
            onClick={onClose}
            className="relative z-10 size-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#E63946] transition-colors"
          >
            <span className="material-symbols-outlined text-sm">close</span>
          </button>
        </header>

        <div className="p-6 md:p-8 bg-[#F6F8FB]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-8 bg-white p-6 rounded-[24px] shadow-sm border border-slate-100">
            <div>
              <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5">
                Email Address
              </p>
              <p className="text-sm font-bold text-[#0B1C2D] break-all flex items-center gap-2">
                <span className="material-symbols-outlined text-[16px] text-slate-300">
                  mail
                </span>
                {lead.email}
              </p>
            </div>
            <div>
              <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5">
                Phone Number
              </p>
              <p className="text-sm font-bold text-[#0B1C2D] flex items-center gap-2">
                <span className="material-symbols-outlined text-[16px] text-slate-300">
                  call
                </span>
                {lead.phone}
              </p>
            </div>
            <div>
              <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5">
                Estimated Budget
              </p>
              <p className="text-sm font-black text-[#E63946] bg-[#E63946]/10 w-fit px-3 py-1.5 rounded-lg border border-[#E63946]/20">
                {lead.budget}
              </p>
            </div>
            <div>
              <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5">
                Date Submitted
              </p>
              <p className="text-sm font-bold text-[#0B1C2D] flex items-center gap-2">
                <span className="material-symbols-outlined text-[16px] text-slate-300">
                  calendar_month
                </span>
                {lead.createdAt
                  ? new Date(lead.createdAt).toLocaleString(undefined, {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "Unknown"}
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-[10px] font-black text-[#0B1C2D] uppercase tracking-widest mb-3 flex items-center gap-2 ml-2">
              <span className="material-symbols-outlined text-[16px] text-[#E63946]">
                description
              </span>
              Project Details & Goals
            </h4>
            <div className="bg-white p-6 md:p-8 rounded-[24px] shadow-sm border border-slate-100">
              <p className="text-sm text-slate-600 font-medium leading-relaxed whitespace-pre-wrap">
                {lead.message || "No project details provided."}
              </p>
            </div>
          </div>

          <div className="mt-8 flex flex-col-reverse sm:flex-row justify-end gap-3">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-6 py-4 rounded-2xl font-black text-xs uppercase tracking-widest text-slate-500 hover:bg-slate-200 transition-colors"
            >
              Close
            </button>
            <button
              onClick={() => {
                onReply(lead);
                onClose();
              }}
              className="w-full sm:w-auto px-8 py-4 bg-[#0B1C2D] text-white rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-[#E63946] shadow-xl shadow-[#0B1C2D]/20 transition-all flex items-center justify-center gap-2"
            >
              Reply to Lead{" "}
              <span className="material-symbols-outlined text-sm">send</span>
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
export default LeadModal;
